<template>
    <div>
        <app-page-header></app-page-header>
        <root-parking-occupancy v-if="role == 'admin'"></root-parking-occupancy>
        <user-parking-occupancy v-else></user-parking-occupancy>
        
    </div>
</template>

<script>

import { getUserApplicationRole, getUserApplicationPermissions } from '@/helpers/utilities.js'

const RootParkingOccupancy = () => import('@/views/RootParkingOccupancy.vue');
const UserParkingOccupancy = () => import('@/views/UserParkingOccupancy.vue');

export default {
    components: {
        RootParkingOccupancy,
        UserParkingOccupancy
    },

    data: () => ({
        role: null   
    }),

    created() {
        this.$store.dispatch('ROUTE_NAME', this.$route.name) 
        this.role = getUserApplicationRole()
        
        //window.console.log("User Applicataion Role: ")
        //window.console.log(getUserApplicationRole())
    },

    mounted() {
       
    },

    destroyed() {

    }
}

</script>

<style scoped>

</style>